<template>
  <el-row>
    <el-col>
      <el-breadcrumb separator="/" class="admincrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>店铺</el-breadcrumb-item>
        <el-breadcrumb-item>标签管理</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <el-col class="'toolbar" style="text-align: right;">
      <el-form :inline="true" :model="sData" size="mini" class="form-inline">
        <el-form-item label="标签组名称">
          <el-input v-model="sData.showName_contains" placeholder="请输入标签组名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button-group>
            <el-button type="primary" @click="sSubmit"><i class="el-icon-search" style="font-weight: bolder; margin-right: 6px;"></i>标签组搜索</el-button>
            <el-button type="primary" @click="dialogVisible = true"><i class="el-icon-circle-plus-outline" style="font-weight: bolder; margin-right: 6px;"></i>新增属性组</el-button>
          </el-button-group>
        </el-form-item>
      </el-form>
    </el-col>
    <el-col>
      <el-row>
        <el-col :span="14">
          <el-col>
            <el-table :data="tableData"  @current-change="handleCurrentChange" stripe style="width: 100%">
              <el-table-column prop="ID" label="分组ID" width="100"></el-table-column>
              <el-table-column prop="showName" label="系统名称" width="200"></el-table-column>
              <el-table-column prop="name" label="店铺名称" width="200"></el-table-column>
              <el-table-column prop="isCartAttri" :formatter="isCartAttri" label="购物选项" width="150"></el-table-column>
              <el-table-column prop="status" :formatter="gpStatus" label="状态" width="100"></el-table-column>
              <el-table-column fixed="right" label="操作" width="200">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="handGroupEgitChange(scope.row)">编辑</el-button>
                  <el-button type="text" size="small" @click="handleMarkGroupCartChange(scope.row)">购物车</el-button>
                  <el-button @click="handleAttriGroupStateChange(scope.row)" type="text" size="small">状态</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col>
            <el-pagination @current-change="gppageNext" :current-page="currentPage" :page-size="10" layout="total, prev, pager, next, jumper" :total="pagenav.total">
            </el-pagination>
          </el-col>
          <el-dialog :visible.sync="editdGroupVisible" :before-close="handleClose" width="30%">
            <span>
                <el-form :model = "groupeditdata" ref= "groupeditdata" :rules="rules" label-width="100px" class="gpform">
                  <el-form-item label="系统名称" prop="showName" require>
                    <el-input v-model="groupeditdata.showName" placeholder="请输入系统名称"></el-input>
                  </el-form-item>
                  <el-form-item label="店铺名称" prop="name" require>
                    <el-input v-model="groupeditdata.name" placeholder="请输入店铺名称"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button @click="editdGroupVisible = false">取 消</el-button>
                    <el-button type="primary" @click="updategpattri">确 定</el-button>
                  </el-form-item>
                </el-form>
              </span>
          </el-dialog>
        </el-col>
        <el-col :span="10" class="edittags">
          <el-row>
            <el-col>
              <el-card class="box-card">
                <div slot="header" class="clearfix" id="mycardbox">
                  <span v-if="currTableCol.showName">
                    <i class="fa fa-tags"></i><span class="tagtitle">当前属性组：</span>{{ currTableCol.showName }}
                  </span>
                  <span v-else>
                    <i class="el-icon-error"></i> 当前未选中属性组
                  </span>
                  <el-button class="attributeaddicon" @click="addattriDialogVisible=true" type="danger" style="float: right; padding: 3px 0"><i class="el-icon-circle-plus"></i>新增属性</el-button>
                  <el-dialog :visible.sync="addattriDialogVisible" :before-close="handleClose" width="30%">
                    <span>
                        <el-form :model = "newattri" ref= "newattri" :rules="rules" label-width="100px" class="gpform">
                          <el-form-item label="系统名称" prop="showName">
                            <el-input v-model="newattri.showName" placeholder="请输入系统名称"></el-input>
                          </el-form-item>
                          <el-form-item label="店铺名称" prop="name" require>
                            <el-input v-model="newattri.name" placeholder="请输入店铺名称"></el-input>
                          </el-form-item>
                          <el-form-item label="图片选项">
                            <el-switch v-model="newattri.isImages"></el-switch>
                          </el-form-item>
                          <el-form-item>
                            <el-button @click="addattriDialogVisible = false">取 消</el-button>
                            <el-button type="primary" @click="addAttribute">确 定</el-button>
                          </el-form-item>
                        </el-form>
                      </span>
                  </el-dialog>
                </div>
                <div class="text item">
                  <span v-if="attriList.length === 0" class="withoutattribute">
                    <i class="el-icon-circle-close-outline"></i>当前属性组未配置属性或则未选择属性组</span>
                  <span v-else v-for="tag in attriList" :key="tag.ID">
                    <span @click="editcurrattri(tag)"  v-if="tag.status"><el-tag size="medium" closable class="tagtarget" type="success" @close="handleTagStatus(tag.ID)">{{ tag.showName }}</el-tag></span>
                    <span @click="editcurrattri(tag)"  v-else><el-tag size="medium" closable class="tagtarget" type="danger" @close="handleTagStatus(tag.ID)">{{ tag.showName }}</el-tag></span>
                  </span>
                  <el-col :span="24" slot="footer" class="tagnotify">
                    <i class="fa fa-bullhorn"></i>红色为禁用标签，绿色为可用标签
                  </el-col>
                  <el-dialog :visible.sync="editattribox" :before-close="handleClose" width="30%">
                    <span>
                        <el-form :model = "curreditattri" ref= "editattricell" :rules="rules" label-width="100px" class="editattricell">
                          <el-form-item label="系统名称" prop="showName">
                            <el-input v-model="curreditattri.showName" placeholder="请输入系统名称"></el-input>
                          </el-form-item>
                          <el-form-item label="店铺名称" prop="name" require>
                            <el-input v-model="curreditattri.name" placeholder="请输入店铺名称"></el-input>
                          </el-form-item>
                          <el-form-item label="图片选项">
                            <el-switch v-model="curreditattri.isImages"></el-switch>
                          </el-form-item>
                          <el-form-item>
                            <el-button @click="editattribox = false">取 消</el-button>
                            <el-button type="primary" @click="editAttribute('editattricell')">确 定</el-button>
                          </el-form-item>
                        </el-form>
                      </span>
                  </el-dialog>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-col>
    <el-dialog :visible.sync="dialogVisible" :before-close="handleClose" width="30%">
      <span>
          <el-form :model = "gpadddata" ref= "gpadddata" :rules="rules" label-width="100px" class="gpform">
            <el-form-item label="系统名称" prop="showName" require>
              <el-input v-model="gpadddata.showName" placeholder="请输入系统名称"></el-input>
            </el-form-item>
            <el-form-item label="店铺名称" prop="name" require>
              <el-input v-model="gpadddata.name" placeholder="请输入店铺名称"></el-input>
            </el-form-item>
            <el-form-item label="购物车选项">
              <el-switch v-model="gpadddata.isCartAttri"></el-switch>
            </el-form-item>
            <el-form-item>
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="applygpattri">确 定</el-button>
            </el-form-item>
          </el-form>
        </span>
    </el-dialog>
  </el-row>
</template>
<script>
export default {
  name: 'Attri',
  data () {
    return {
      loading: true,
      tableData: [],
      sData: {},
      dialogVisible: false,
      addattriDialogVisible: false,
      gpadddata: {isCartAttri: false},
      pagenav: {total: 0},
      rules: {
        showName: [{ required: true, message: '系统名称不能为空', trigger: 'blur' }],
        name: [{ required: true, message: '店铺名称不能为空', trigger: 'blur' }]
      },
      attriGroup: {},
      currentPage: 1,
      enableTags: [],
      disableTags: [],
      currTableCol: {},
      newattri: {},
      attriList: [],
      groupeditdata: {},
      editdGroupVisible: false,
      editattribox: false,
      curreditattri: {},
      editattributetemp: {}
    }
  },
  mounted: function () {
    this.gppageNext(1)
  },
  methods: {
    editcurrattri (curr) {
      this.curreditattri = curr
      this.editattribox = true
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    handleTagStatus: function (gid) {
      var params = {
        gid: gid,
        method: 'base.attristatus'
      }
      var that = this
      this.$http.post(that.$apiurl, params).then(function (ret) {
        if (ret.body.data.code === 200) {
          this.$message.success('属性状态更新成功!')
          that.loadAttribute()
        } else {
          this.$alert('属性状态更新失败，请稍后重试!')
        }
      })
    },
    handGroupEgitChange (row) {
      console.log(row)
      this.groupeditdata = row
      this.editdGroupVisible = true
    },
    handleCurrentChange (val) {
      this.currTableCol = val
      this.loadAttribute()
    },
    handleAttriGroupStateChange (row) {
      var data = {
        gid: row.ID,
        method: 'base.attrigroupstatus'
      }
      var that = this
      this.$http.post(that.$apiurl, data).then(function (ret) {
        if (ret.body.code === 200) {
          this.$message.success('属性组状态更新成功!')
          that.gppageNext(that.currentPage)
        } else {
          this.$alert('属性组状态更新失败，请稍后重试!')
        }
      })
    },
    handleMarkGroupCartChange (row) {
      var data = {
        gid: row.ID,
        method: 'base.attrigroupiscart'
      }
      var that = this
      this.$http.post(that.$apiurl, data).then(function (ret) {
        if (ret.body.code === 200) {
          this.$message.success('属性组购物车状态更新成功!')
          that.gppageNext(that.currentPage)
        } else {
          this.$alert('属性组购物车状态更新失败，请稍后重试!')
        }
      })
    },
    isCartAttri (data) {
      if (data.isCartAttri) {
        return ('购物车标签组')
      } else {
        return ('非购物车标签组')
      }
    },
    gpStatus (data) {
      if (data.status) {
        return ('启用')
      } else {
        return ('禁用')
      }
    },
    applygpattri: function (e) {
      e.preventDefault()
      var data = this.gpadddata
      data['method'] = 'base.insertattrigroup'
      var that = this
      that.$refs['gpadddata'].validate(valid => {
        if (valid) {
          this.$http.post(that.$apiurl, data).then(function (ret) {
            if (ret.body.code === 200) {
              this.$message.success('属性组更新成功!')
              this.dialogVisible = false
              this.gppageNext(1)
            } else {
              this.$alert('属性组更新失败，请稍后重试!')
            }
          })
        } else {
          that.$alert('请检查表单参数')
        }
      })
    },
    gppageNext: function (page, num = 10) {
      var parmas = this.sData
      var that = this
      parmas['page'] = page
      parmas['num'] = num
      parmas['method'] = 'base.attrigrouppage'
      this.currentPage = page
      this.$http.post(that.$apiurl, parmas).then(function (ret) {
        that.tableData = ret.body.data.data
        var page = {
          total: ret.body.data.count
        }
        that.pagenav = page
      })
    },
    addAttribute: function (e) {
      e.preventDefault()
      if (this.currTableCol.showName !== undefined) {
        var params = this.newattri
        params['method'] = 'base.addattribute'
        params['gid'] = this.currTableCol.ID
        var that = this
        that.$refs['newattri'].validate(valid => {
          this.$http.post(that.$apiurl, params).then(function (ret) {
            if (ret.body.code === 200) {
              this.$message.success('新属性申请成功')
              that.addattriDialogVisible = false
            } else {
              this.$alert('新属性申请失败，请稍后重试!')
            }
          })
        })
      } else {
        this.$alert('未指明属性组，请先选择属性所在属性组！')
      }
    },
    loadAttribute: function () {
      if (this.currTableCol.showName !== undefined) {
        var params = {
          method: 'base.groupattribute',
          gid: this.currTableCol.ID
        }
        var that = this
        this.$http.post(that.$apiurl, params).then(function (ret) {
          if (ret.body.code === 200) {
            that.attriList = ret.body.data
          } else {
            that.$alert('标签组标签加载失败，请稍后重试！')
          }
        })
      } else {
        this.$alert('未指明属性组，请先选择属性所在属性组！')
      }
    },
    updategpattri: function () {
      var parmas = this.groupeditdata
      parmas['method'] = 'base.updateattributegroup'
      var that = this
      this.$http.post(that.$apiurl, parmas).then(function (ret) {
        if (ret.body.data.code === 200) {
          that.$message.success('标签组更新成功')
          that.editdGroupVisible = false
        } else {
          that.$alert('标签组更新失败，请稍后重试！')
        }
      })
    },
    editAttribute: function (formName) {
      var that = this
      that.$refs[formName].validate(valid => {
        if (valid) {
          var data = {
            method: 'base.attributupdate',
            tid: that.curreditattri.ID,
            showName: that.curreditattri.showName,
            name: that.curreditattri.name,
            isImages: that.curreditattri.isImages
          }
          that.$http.post(that.$apiurl, data).then(function (ret) {
            console.log(ret.body)
            if (ret.body.data.code === 200) {
              that.$message.success('标签修改成功')
              that.loadAttribute()
              that.editattribox = false
            }
          })
        } else {
          that.$alert('请检查表单是否正确真写!')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shop/Attri.vue